/**
 * Last-line readability guard for a logo shown on a mismatched-darkness
 * surface (a dealer who uploaded only one tone of a mark family). When
 * `plate` is true, the mark sits on a subtle light plate so a dark logo
 * never disappears on a dark header/footer. Calm by design — a quiet
 * rounded backdrop, never a loud frame. When `plate` is false this is a
 * pass-through, so the common path renders the bare <Image>.
 *
 * The darkness decision is made once at the storefront layout boundary by
 * `resolveSurfaceLogo`; this component only consumes the resulting boolean.
 */
export function LogoContrastPlate({
  plate,
  children,
}: {
  plate?: boolean
  children: React.ReactNode
}) {
  if (!plate) return <>{children}</>
  return (
    <span className="inline-flex items-center rounded-md bg-white/90 px-2 py-1">
      {children}
    </span>
  )
}
